import Manager from "../../src/manager";
import React from "react";
import Functions from "../../src/functions";

function Mapper(data, status, response, error, component) {
	let output = [];

	if (data) {
		output.push({ data: data });
		sessionStorage.setItem("rli", data.item.rli);
		sessionStorage.setItem("pendingStatus", data.item.status);
	}
	return output;
}
function clickMeTerm(_this) {
	let id = _this.props.primaryKey;
	let manager = _this.props.manager;
	window["modal"].setState({
		targetComponent: this,
		show: true,
		callback: function (args) {
			window["modal"].setState({ show: false });
			setTimeout(manager.refresh, 2000);
		},
		// footer: [],
		body: (
			<Manager
				key="modalForTerms"
				module="modalForTerms"
				data={_this.props.data}
				view="list"
				ref={(refComponent) => {
					window["modalbody"] = refComponent;
				}}></Manager>
		),
	});
}

function clickMeAccessibilityStatement() {
	window.open("./resources/pdf/accessibility-statement.html", "_blank");
}

function clickMeTermVat(_this) {
	let manager = _this.props.manager;
	window["modal"].setState({
		targetComponent: this,
		show: true,
		callback: function (args) {
			window["modal"].setState({ show: false });
			setTimeout(manager.refresh, 2000);
		},
		body: (
			<Manager
				key="modalForTermVat"
				module="modalForTermVat"
				data={_this.props.data}
				view="list"
				ref={(refComponent) => {
					window["modalbody"] = refComponent;
				}}></Manager>
		),
	});
}

function Properties(args) {
	let editable = args.editable ? true : false;
	return {
		header: {
			alias: "header",
			type: "module",
			configuration: {
				module: "header",
				view: "list",
			},
			editable,
		},
		infoPanel: {
			alias: "infoPanel",
			type: "module",
			configuration: {
				module: "infoPanel",
				view: "list",
			},
			editable,
		},
		footer: {
			alias: "footer",
			type: "module",
			configuration: {
				module: "footer",
				view: "list",
			},
			editable,
		},
		showVatHybrid: {
			alias: "showVatHybrid",
			type: "text",
			label: "",
			placeholder: "",
			useCustomUI: true,
			customUI: function () {
				let data = this.props.data;
				let _this = this;
				let landPageData = JSON.parse(sessionStorage.landPageData);
				let UserType = Functions["custom"]["getUserType"]();
				return (
					<>
						<div
							className="renewal-time customeClassReloadBundleDiv vatmsg"
							id="renewal-time2">
							Τιμές με ΦΠΑ και{" "}
							<a
								style={{ cursor: "pointer" }}
								onClick={(e) => clickMeTermVat(_this)}
								className={
									UserType === "HYBRID_RESIDENTIAL_COST_CONTROL" &&
									landPageData.contractInfoCarrier.inListOfWhatuspCss
										? "terms open-lightbox vatterms"
										: "terms" + " open-lightbox vattermscc"
								}>
								Τέλος Συνδρομητών Κινητής Τηλεφωνίας
							</a>
							&nbsp;10%, όπου αυτό εφαρμόζεται.
						</div>
					</>
				);
			},
		},
		showTerms: {
			alias: "showTerms",
			type: "text",
			label: "",
			placeholder: "",
			useCustomUI: true,
			customUI: function () {
				let data = this.props.data;
				let _this = this;
				return (
					<div
						className="footer"
						id="footer">
						<div
							className="hold"
							style={{
								display: "flex",
								flexDirection: "column",
								justifyContent: "center",
							}}>
							<a
								className="terms open-lightbox"
								style={{ cursor: "pointer", lineHeight: "30px" }}
								onClick={(e) => clickMeTerm(_this)}>
								Όροι &amp; Προϋποθέσεις &gt;{" "}
							</a>
							<a
								className="terms open-lightbox"
								style={{ cursor: "pointer", lineHeight: "30px" }}
								onClick={(e) => clickMeAccessibilityStatement()}>
								Δήλωση Προσβασιμότητας &gt;{" "}
							</a>
						</div>
					</div>
				);
			},
		},
		main: {
			alias: "main",
			type: "module",
			configuration: {
				module: "cosmoteAvailableContracts",
				view: "list",
			},
		},
		activate: {
			alias: "activate",
			type: "module",
			configuration: {
				module: "activatePage",
				view: "list",
			},
		},
		error: {
			alias: "error",
			type: "module",
			configuration: {
				module: "errorPage",
				view: "list",
			},
		},
	};
}

const Main = {
	auth: "",
	views: {
		list: {
			apis: {
				view: {
					url: "/service/checkOrderStatus?t={t}",
					method: "POST",
					replace: {
						t: function () {
							return new Date().getTime();
						},
					},
					mapper: Mapper,
				},
			},
			template: "plain",
			templateConfiguration: {
				includeProperties: ["none"],
				cardTopTemplate: function () {
					let data = this.state.data[0];
					let UserType = Functions["custom"]["getUserType"]();
					let landPageData = JSON.parse(sessionStorage.landPageData);
					if (!landPageData.contractInfoCarrier.hasLPService) {
						return (
							<>
								{data.header.component}
								{data.activate.component}
							</>
						);
					} else if (landPageData.contractInfoCarrier.hasLPService) {
						return (
							<>
								{data.header.component}
								{/*{data.infoPanel.component}*/}
								{data.main.component}
								{UserType === "HYBRID_RESIDENTIAL_COST_CONTROL"
									? data.showVatHybrid.component
									: null}
								{data.showTerms.component}
							</>
						);
					} else {
						return (
							<>
								{data.header.component}
								{data.error.component}
							</>
						);
					}
				},
				excludeProperties: [],
				events: { onClick: function (e) {} },
			},
			properties: Properties({ editable: false }),
			primaryKey: "id",
		},
	},
};

export default Main;
